function updateIframe() {
  const input = document.getElementById("awbInput").value.trim();
  if (!input) return alert("Please enter an Order ID or AWB tracking number");

  fetch(`https://bluedart.marmeto.com/api/order/number/${input}?store=simple`)
    .then(res => res.json())
    .then(result => {
      const shipment = result?.data?.Shipment?.[0];
      if (!shipment) {
        alert("Your order is confirmed, please check after some time");
        return;
      }

      document.querySelector(".custom-track-order-wrapper").style.display = "block";

      const scans = shipment.Scans || [];
      const status = shipment.Status || "";
      const eta = shipment.ExpectedDelivery || "";
      const pickupDate = shipment.PickUpDate || shipment.StatusDate;

      const steps = document.querySelectorAll(".delivery_status__step");
      steps.forEach(step => step.classList.remove("completed"));

      // Step 1: Order Confirmed
      steps[0]?.classList.add("completed");

      let isInTransit = false;
      let isOutForDelivery = false;

      scans.forEach(s => {
        const scanText = s?.ScanDetail?.Scan?.toLowerCase() || "";
        if (scanText.includes("arrived") || scanText.includes("picked up") || scanText.includes("connected")) {
          isInTransit = true;
        }
        if (scanText.includes("out for delivery")) {
          isOutForDelivery = true;
        }
      });

      if (isInTransit || isOutForDelivery || status.toLowerCase().includes("delivered")) {
        steps[1]?.classList.add("completed"); // In Transit
      }

      if (isOutForDelivery || status.toLowerCase().includes("delivered")) {
        steps[2]?.classList.add("completed"); // Out for Delivery
      }

      if (status.toLowerCase().includes("delivered")) {
        steps[3]?.classList.add("completed"); // Delivered
      }

      // Get the last completed step's text as status
      let statusText = "Order Confirmed";
      const completedSteps = Array.from(steps).filter(step => step.classList.contains("completed"));
      if (completedSteps.length > 0) {
        statusText = completedSteps[completedSteps.length - 1].textContent.trim();
      }


      // Handle delivery ETA display
      const deliveryWrapper = document.querySelector(".custom-track-order-delivery-wrapper");
      if (statusText === "Order delivered" || !eta) {
        deliveryWrapper.style.display = "none";
        document.querySelector(".to-delivery-status").textContent = statusText;
      } else {
        const etaDate = new Date(eta);
        document.querySelector(".to-delivery-date").textContent = etaDate.getDate();
        document.querySelector(".to-delivery-month").textContent = etaDate.toLocaleString('default', { month: 'long' });
        document.querySelector(".to-deliver-year").textContent = etaDate.getFullYear();
        document.querySelector(".to-delivery-status").textContent = statusText;
        deliveryWrapper.style.display = "block";
      }

      document.querySelector(".order-id-display").textContent = input;
      document.querySelector(".pickup-date-display").textContent = formatDate(pickupDate);
    })
    .catch(err => {
      console.error("Error fetching shipment data:", err);
    });
}

function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}
